import {mysql2DDMMYYYY, mysql2HHMM} from "@/utils/date";
import {nick} from "@/utils/user";
import store from "@/store";

export const ACTIONS = {
    CREATE: "create",
    UPDATE: "update",
    DISCUSS: "discuss",
    DEFER: "defer",
    UNDEFER: "undefer",
    DELAY: "delay",
    UNDELAY: "undelay",
    DONE: "done",
    UNDONE: "undone",
    PRIO: "prio",
    UNPRIO: "unprio",
    ASSIGN: "assign",
    UNASSIGN: "unassign",
    DEADLINE: "deadline",
    UNDEADLINE: "undeadline",
    DELETE: "delete",
    UNDELETE: "undelete",
    MOVE: "move",
    PLACE: "place",
    START: "start",
    STOP: "stop",
    ACCESS_REQUEST: "AccessRequest",
    GRANT_ACCESS: "GrantAccess",
    REVOKE_ACCESS: "RevokeAccess",
};

export const TAB_MSGS = "msgs";
export const TAB_PINS = "pins";
export const TAB_FILES = "files";
//export const TAB_NAMES = [TAB_ACTUAL, TAB_DELAYED, TAB_DONE, TAB_TEMPLATES];

export const actions = [

    /*{text: "Готово!"},
    {text: "Мало информации"},
    {text: "Требуется помощь"},*/
    {
        id: ACTIONS.CREATE,
        //label: "Готово!", icon: "mdi-check",
        //text: "Задача выполнена",
        //type: "success",
        msg: "создал задачу",   //@deprecated
        content: "создал задачу",
    },
    {
        id: ACTIONS.DONE,
        label: "Готово!",
        icon: "mdi-check",
        text: "Задача выполнена",
        type: "success",
        msg: "отметил 'Выполнено'",   //@deprecated
        content: "отметил 'Выполнено'",
    },
    {
        id: ACTIONS.UNDONE,
        //label: "Не готово!", icon: "mdi-check",
        text: "Задача НЕ выполнена",
        type: "warning",
        msg: "отметил 'Не выполнено'",   //@deprecated
        content: "возобновил задачу",
    },
    {
        id: ACTIONS.DEFER,
        label: "Ждем",
        icon: "mdi-timer-sand",
        //icon: "mdi-pause",
        text: "Задача в режиме ожидания",
        texted: "Задача в режиме ожидания",
        withCalendar: true,
        type: "info",
        msg: "поставил задачу в режим ожидания",   //@deprecated
        //content: "отложил задачу {{delayedTill}}",
        content: (item) => {
            return "поставил задачу в режим ожидания";
        }
    },
    {
        id: ACTIONS.UNDEFER,
        msg: "возобновил задачу",   //@deprecated
        content: "возобновил задачу",
    },
    {
        id: ACTIONS.DELAY,
        label: "Отложить",
        //icon: "mdi-timer-sand",
        icon: "mdi-pause",
        text: "Задача откладывается",
        texted: "Задача отложена",
        withCalendar: true,
        type: "info",
        msg: "отложил задачу {{delayedTill}}",   //@deprecated
        //content: "отложил задачу {{delayedTill}}",
        content: (item) => {
            let text = "отложил задачу ";
            console.log("item.actionData", item.actionData);
            if (item.actionData?.delayedTill) {
                const delayedTill = item.actionData.delayedTill;
                if (delayedTill) {
                    let hm = mysql2HHMM(delayedTill);
                    if (hm === "00:00") hm = "";
                    else hm = " " + hm;
                    text += " до " + mysql2DDMMYYYY(delayedTill) + hm;
                } else text += "бессрочно";
            }
            return text;
        }
    },
    {
        id: ACTIONS.UNDELAY,
        msg: "возобновил задачу",   //@deprecated
        content: "возобновил задачу",
    },
    {
        id: ACTIONS.PRIO,
        //label: "Важно!",
        icon: "mdi-fire",
        text: "Важная задача!",
        type: "error",
        msg: "поставил приоритет '{{prioText}}'",   //@deprecated
        content: "поставил приоритет '{{prioText}}'",
    },
    {
        id: ACTIONS.UNPRIO,
        msg: "снял приоритет",   //@deprecated
        content: "снял приоритет",
    },
    {
        // @deprecated
        id: ACTIONS.DISCUSS,
        label: "Уточнить",
        icon: "mdi-chat-question-outline",
        text: "{{user.name}} просит {{assignee.name}} обсудить задачу",
        type: "warning",
        msg: "запросил обсуждение задачи",   //@deprecated
        content: "запросил обсуждение задачи",
        isForAssigneeOnly: true,
        withAssigneeMenu: true,
    },
    {
        id: ACTIONS.ASSIGN,
        //label: "Уточнить",
        icon: "mdi-chat-question-outline",
        type: "warning",
        msg: "назначил задачу на {{assignee}}",   //@deprecated
        content: (item) => {
            let name;
            let assignee = item.actionData?.assignee;
            if (assignee) {
                const user = store.state.session.area.users?.find(el => el.id === assignee.id);
                if (user) name = nick(user);
                else name = assignee.name;
            }
            if (name) return "назначил задачу на " + name;
            return "назначил задачу на неизвестного пользователя";
        },
    },
    {
        id: ACTIONS.UNASSIGN,
        //label: "Уточнить",
        icon: "mdi-chat-question-outline",
        type: "info",
        msg: "убрал ответственного с задачи",   //@deprecated
        content: "убрал ответственного с задачи",
    },
    {
        id: ACTIONS.DEADLINE,
        //label: "Готово!", icon: "mdi-check",
        //text: "Задача выполнена",
        type: "warning",
        msg: "поставил дедлайн {{deadline}}",   //@deprecated
        content: "поставил дедлайн {{deadline}}",
    },
    {
        id: ACTIONS.UNDEADLINE,
        content: "убрал дедлайн",
    },
    {
        id: ACTIONS.DELETE,
        //label: "Не готово!", icon: "mdi-check",
        text: "Задача удалена",
        type: "info",
        //msg: "отметил 'Не выполнено'",   //@deprecated
        content: "удалил задачу",
    },
    {
        id: ACTIONS.UNDELETE,
        //label: "Не готово!", icon: "mdi-check",
        text: "Задача восстановлена",
        type: "info",
        //msg: "отметил 'Не выполнено'",   //@deprecated
        content: "восстановил задачу",
    },
    {
        id: ACTIONS.MOVE,
        //label: "Уточнить",
        content: (item) => {
            let text = ["переместил задачу"];
            if (item.actionData) {
                if (item.actionData.group && item.actionData.oldGroup && item.actionData.group.id !== item.actionData.oldGroup.id) {
                    text.push("в группу '"+item.actionData.group.name+"'");
                }
                if (item.actionData.parent && item.actionData.parent.id !== item.actionData.oldParent?.id) {
                    text.push("внутрь '" + item.actionData.parent.title + "'");
                }
                else if (item.actionData.oldParent && !item.actionData.parent) {
                    text.push("на верхний уровень");
                }
            }
            return text.join(" ");
        },
    },
    {
        id: ACTIONS.PLACE,
        content: (item) => {
            let text = ["разместил задачу"];
            //console.log("COMMENT DATA", item);
            if (item.actionData) {
                if (item.actionData.group) {
                    text.push("в группу '"+item.actionData.group.name+"'");
                }
                if (item.actionData.parent) {
                    text.push("внутрь '" + item.actionData.parent.title + "'");
                }
                else {
                    text.push("на верхний уровень");
                }
            }
            return text.join(" ");
        },
    },
    {
        id: ACTIONS.START,
        //label: "Уточнить",
        content: (item) => {
            return "начал работать над задачей";
        },
    },
    {
        id: ACTIONS.STOP,
        content: (item) => {
            return "прекратил работать над задачей";
        },
    },
    {
        id: ACTIONS.ACCESS_REQUEST,
        content: (item) => {
            if (item.actionData?.withFullAccess) {
                return "запросил полный доступ к задаче";
            }
            return "запросил доступ к задаче";
        },
    },
    {
        id: ACTIONS.GRANT_ACCESS,
        content: (item) => {
            if (item.actionData?.userName) {
                if (item.actionData?.withFullAccess) {
                    return "открыл полный доступ для пользователя " + item.actionData?.userName;
                }
                else {
                    return "открыл доступ на чтение для пользователя " + item.actionData?.userName;
                }
            }
            return "открыл доступ к задаче для неустановленного пользователя";
        },
    },
    {
        id: ACTIONS.REVOKE_ACCESS,
        content: (item) => {
            if (item.actionData?.userName) {
                return "закрыл доступ для пользователя "+item.actionData?.userName;
            }
            return "закрыл доступ к задаче для неустановленного пользователя";
        },
    },
    /*{label: "Задержка", icon: "mdi-chat-question-outline" text: "По данной задаче требуется дополнительное время"},*/
]